import * as ng from 'angular';
import * as _ from 'underscore';

ng.module('e360')
   .directive('nvUrl', urlDirective);

/**
 * Directive to automatically add protocol to URL's on a input[type=text].
 */
function urlDirective(): ng.IDirective {
   return {
      restrict: 'A',
      require: 'ngModel',
      link: urlDirectiveLinkFn
   };
}

export function urlDirectiveLinkFn(scope, element, attrs, ngModel) {
   let protocols = attrs.nvUrl ? attrs.nvUrl.split(',') : ['https'];

   ngModel.$parsers.push(function (inputValue) {
      // set empty string to null to avoid unnecessary validation errors
      let transformedInput = inputValue == '' ? null : inputValue;

      if (transformedInput != inputValue) {
         ngModel.$setViewValue(transformedInput);
         ngModel.$render();
      }

      return transformedInput;
   });

   // Must add protocol to string on blur because putting this in
   // ngModel.$parsers would not allow someone to use backspace to
   // delete protocol.
   element.bind('blur', nvUrlOnBlur);
   function nvUrlOnBlur() {
      let input = ngModel.$viewValue;

      // Check to see if the input is a url with a protocol.
      // If it is and the protocol is malformed or invalid then correct it.
      // If not then prepend the input with an accepted protocol.
      if (input) {
         if (input.indexOf('://') != -1) {// if the input is in the form of a url
            let inputValues = input.split('://');
            if (!_.contains(protocols, inputValues[0])) {
               // if the protocol from the input is not one of the accepted ones
               // then replace it
               input = protocols[0] + '://' + inputValues[1];
            }
         } else {
            // if the input has no protocol then prepend one
            input = protocols[0] + '://' + input;
         }
      }

      if (ngModel.$viewValue != input) {
         ngModel.$setViewValue(input);
         ngModel.$render();
      }
   }
}
